import logo from './redIcon.png';
import './App.css';
import React from "react";

import Footer from "./Footer";

import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";

import { useState, useEffect, useRef } from 'react';
import { firestore, auth } from "./firebase";

let cache = [];

signInWithEmailAndPassword(auth, "tornadowizard123@gmail.com", process.env.PASSWORD);

async function SearchData(search) {
  if (cache.length === 0) cache = await getDocs(collection(firestore, "Packs"));
  let packsFound = [];
  if (search.tags.length === 0) search.tags = ["Traditional", "Story", "Difficult", "Sequel", "Kaizo", "Gimmick", "Decoration", "Friends", "Ability", "Purple"];
  if (search.status.length === 0) search.status = ["Complete", "Demo", "Beta"];
  //if (search.keyword.length === 0 && search.tags.length === 10 && search.status.length === 3) return "Please use some search queries!";
  cache.forEach(doc => {
    let nope = false;
    if (search.keyword !== "" && !doc.data().name.toLowerCase().includes(search.keyword.toLowerCase())) nope = true;
    if (doc.data().tags.length !== 0) {
      let foundTag = false;
      doc.data().tags.forEach(tag => {
        if (search.tags.includes(tag)) foundTag = true;
      });
      if (!foundTag) nope = true;
      // Check if pack includes at least one tag specified
    }
    if (!search.status.includes(doc.data().status)) nope = true;
    let packData = {
      id: doc.id,
      name: doc.data().name,
      creator: doc.data().creator,
      status: doc.data().status,
      desc: doc.data().desc
    };
    if (doc.data().tags.length === 0) packData.tags = ["", ""];
    else if (doc.data().tags.length === 1) packData.tags = [doc.data().tags[0], ""];
    else packData.tags = [doc.data().tags[0], doc.data().tags[1]];
    if (!nope) packsFound.push(packData);
  });
  return packsFound;
}

async function GeneratePacks(search, setPackSearch) {
  let allPacksFound = await SearchData(search);
  //if (allPacksFound === "Please use some search queries!") return <div className="text-center text-lg mt-5">{allPacksFound}</div>
  let hugeResult = <div></div>;
  
  if (allPacksFound.length === 0) return <div className="text-center text-lg mt-5">Sorry, no worldpacks found. Try a different search query!</div>

  function FigureOutThree(props) {
    let packsFound = props.packs;
    if (packsFound.length === 1) {
      return (<div className="mt-10 mx-6 md:mx-24 lg:mx-32 grid gap-6 grid-rows-3 grid-cols-1 md:grid-rows-1 md:grid-cols-3">
        <WorldPackPreview id={packsFound[0].id} title={packsFound[0].name} author={packsFound[0].creator} tag1={packsFound[0].tags[0]} tag2={packsFound[0].tags[1]} status={packsFound[0].status} desc={packsFound[0].desc} setPackSearch={setPackSearch}/>
        <div></div>
        <div></div>
      </div>);
    }
    if (packsFound.length === 2) {
      return (<div className="mt-10 mx-6 md:mx-24 lg:mx-32 grid gap-6 grid-rows-3 grid-cols-1 md:grid-rows-1 md:grid-cols-3">
        <WorldPackPreview id={packsFound[0].id} title={packsFound[0].name} author={packsFound[0].creator} tag1={packsFound[0].tags[0]} tag2={packsFound[0].tags[1]} status={packsFound[0].status} desc={packsFound[0].desc} setPackSearch={setPackSearch}/>
        <WorldPackPreview id={packsFound[1].id} title={packsFound[1].name} author={packsFound[1].creator} tag1={packsFound[1].tags[0]} tag2={packsFound[1].tags[1]} status={packsFound[1].status} desc={packsFound[1].desc} setPackSearch={setPackSearch}/>
        <div></div>
      </div>);
    }
    if (packsFound.length === 3) {
      return (<div className="mt-10 mx-6 md:mx-24 lg:mx-32 grid gap-6 grid-rows-3 grid-cols-1 md:grid-rows-1 md:grid-cols-3">
        <WorldPackPreview id={packsFound[0].id} title={packsFound[0].name} author={packsFound[0].creator} tag1={packsFound[0].tags[0]} tag2={packsFound[0].tags[1]} status={packsFound[0].status} desc={packsFound[0].desc} setPackSearch={setPackSearch}/>
        <WorldPackPreview id={packsFound[1].id} title={packsFound[1].name} author={packsFound[1].creator} tag1={packsFound[1].tags[0]} tag2={packsFound[1].tags[1]} status={packsFound[1].status} desc={packsFound[1].desc} setPackSearch={setPackSearch}/>
        <WorldPackPreview id={packsFound[2].id} title={packsFound[2].name} author={packsFound[2].creator} tag1={packsFound[2].tags[0]} tag2={packsFound[2].tags[1]} status={packsFound[2].status} desc={packsFound[2].desc} setPackSearch={setPackSearch}/>
      </div>);
    }
  }

  while (allPacksFound.length > 3) {
    hugeResult = <div>
      {hugeResult}
      <FigureOutThree packs={[allPacksFound[0], allPacksFound[1], allPacksFound[2]]}/>
    </div>;
    allPacksFound.splice(0, 3);
  }
  hugeResult = <div>
    {hugeResult}
    <FigureOutThree packs={allPacksFound}/>
  </div>;
  return hugeResult;
  
}

const TagSelectButton = React.forwardRef((props, ref) => {
  const [color, setColor] = useState("w");
  function toggle() {
    if (color === "w") setColor("g");
    else setColor("w");
  }
  if (color === "g") return <button onClick={toggle} id={props.tag} ref={ref} className="bg-ddg mt-4 px-6 py-1 text-sm rounded-lg">{props.tag}</button>;
  else return <button onClick={toggle} id={props.tag} ref={ref} className="bg-darkgr mt-4 px-6 py-1 text-sm rounded-lg">{props.tag}</button>;
});

const StatusSelectButton = React.forwardRef((props, ref) => {
  const [color, setColor] = useState("d"); // D = dark, B = bright
  function toggle() {
    if (color === "d") setColor("b");
    else setColor("d");
  }
  if (props.status === "Complete") {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddc mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddc mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  } else if (props.status === "Demo") {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddy mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddy mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  } else {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddo mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddo mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  }
});

function TagButton(props) {
  if (props.tag === "") return <div></div>;
  else {
    return (
      <button onClick={() => submit({
        keyword: "",
        tags: [props.tag],
        status: []
      }, props.setPackSearch)} className="bg-ddg mt-5 px-6 py-1 rounded-lg text-base">{props.tag}</button>
    )
  }
}

function StatusButton(props) {
  let button;
  if (props.color === "ddc") button = <button onClick={() => submit({
    keyword: "",
    tags: [],
    status: ["Complete"]
  }, props.setPackSearch)} className="bg-ddc mt-5 px-6 py-1 rounded-lg text-base">{props.status}</button>;
  else if (props.color === "ddy") button = <button onClick={() => submit({
    keyword: "",
    tags: [],
    status: ["Demo"]
  }, props.setPackSearch)} className="bg-ddy mt-5 px-6 py-1 rounded-lg text-base">{props.status}</button>;
  else button = <button onClick={() => submit({
    keyword: "",
    tags: [],
    status: ["Beta"]
  }, props.setPackSearch)} className="bg-ddo mt-5 px-6 py-1 rounded-lg text-base">{props.status}</button>;
  return button;
}

async function submit(searchQuery, setPackSearch) {
  const packsGenerated = await GeneratePacks(searchQuery, setPackSearch);
  setPackSearch(packsGenerated);
}

function WorldPackPreview(props) {
  let statusButton;
  if (props.status === "Complete") statusButton = <StatusButton  color="ddc" setPackSearch={props.setPackSearch} status={props.status}/>;
  else if (props.status === "Demo") statusButton = <StatusButton color="ddy" setPackSearch={props.setPackSearch} status={props.status}/>;
  else statusButton = <StatusButton color="ddo" setPackSearch={props.setPackSearch} status={props.status}/>;

  let tagSection;
  if (props.tag1 !== "") tagSection = <div className="grid grid-cols-1 grid-rows-2 xl:grid-cols-2 xl:grid-rows-1 xl:gap-3">
    <TagButton tag={props.tag1} setPackSearch={props.setPackSearch}/>
    <TagButton tag={props.tag2} setPackSearch={props.setPackSearch}/>
  </div>;
  else tagSection = <div></div>;

  let onClickURL = `/pack/${props.id}`;

  return (
    <div className="bg-darkg px-6 md:px-8 lg:px-12 xl:px-14 pt-12 pb-12 rounded-2xl text-center">
      <p className="text-xl md:text-2xl lg:text-3xl font-bold">{props.title}</p>
      <p className="text-sm md:text-md lg:text-xl">By: {props.author}</p>
      <p className="text-sm mt-3">{props.desc}</p>
      <button onClick={() => window.location.replace(onClickURL)} className="bg-darkc hover:bg-ddc transition duration-50 mt-5 mb-5 px-12 py-2 rounded-lg text-base">View</button>
      <hr/>
      {tagSection}
      {statusButton}
    </div>
  );
}

function Home() {

  const [packSearch, setPackSearch] = useState(null);

  const searchBar = useRef(null);
  
  const tagTraditional = useRef(null);
  const tagStory = useRef(null);
  const tagDifficult = useRef(null);
  const tagKaizo = useRef(null);
  const tagSequel = useRef(null);
  const tagDecoration = useRef(null);
  const tagGimmick = useRef(null);
  const tagFriends = useRef(null);
  const tagAbility = useRef(null);
  const tagPurple = useRef(null);

  const statusComplete = useRef(null);
  const statusDemo = useRef(null);
  const statusBeta = useRef(null);

  return (
    <div className="App bg-gradient-to-br from-ddp to-darkp">
      <header className="App-header pt-32">
        <img src={logo} className="App-logo" alt="logo" />
        <p className="fontTitle text-2xl md:text-4xl lg:text-6xl">
          CaL Pack World
        </p>
      </header>
      <div className="header mt-12">
        <p className="text-xl text-center mx-5">Welcome to Pack World, a community-run site to find worldpacks for the indie game Cats are Liquid!</p>
        <p className="text-xl text-center mx-5">Take a look around, or submit your own worldpack!</p>
        <div className="mt-5 inline-grid gap-6 grid-cols-1 grid-rows-3 sm:grid-cols-3 sm:grid-rows-1">
          <button onClick={() => window.location.replace("/explore")} className="homeButton bg-darkg hover:bg-darkc transition duration-50">Explore Worldpacks</button>
          <button onClick={() => window.location.replace("/submit")} className="homeButton bg-darkg hover:bg-darkc transition duration-50">Submit a Pack</button>
          <button onClick={() => window.location.replace("/discord")} className="homeButton bg-darkg hover:bg-darkc transition duration-50">Join our Discord</button>
        </div>
      </div>
      <div className="header mt-12 mb-10">
      <p className="mt-16 text-2xl md:text-3xl lg:text-4xl fontTitle">Featured Worldpacks</p>
        <div className="mt-10 mx-6 md:mx-24 lg:mx-32 grid gap-6 grid-rows-3 grid-cols-1 md:grid-rows-1 md:grid-cols-3">
          <WorldPackPreview id="LevelReview" title="Level Review" author="National Insurance Clerk / CyanYarnBall / SussyCyan" tag1="Story" tag2="Friends" status="Complete" desc="This is my entry for SusperPhantomUser's worldpack jam, with the theme of 'lost'" setPackSearch={setPackSearch}/>
          <WorldPackPreview id="RainyDay" title="Rainy.day" author="cv" tag1="Story" tag2="Decoration" status="Complete" desc="ever wondered how rushing, being exhausted and tired could turn out in a pack? well, here's the answer." setPackSearch={setPackSearch}/>
          <WorldPackPreview id="MaximumSpeed" title="Maximum Speed" author="BluuBerry" tag1="Traditional" tag2="Decoration" status="Complete" desc="A JAM PACK submission by BluuBerry with the future theme, it's really short." setPackSearch={setPackSearch}/>
        </div>
      </div>
      <br/>
      <Footer/>
    </div>
  );
}

export default Home;